import React from "react";

export default class Account extends React.Component {
    render() {
        return <div>Account</div>;
    }
}
